import { assertValue } from './types';

export type QueryString = Record<string, string[]>;

export function parseQuery(query: string): QueryString {
  if (query.startsWith('?')) {
    query = query.substring(1);
  }

  const result: QueryString = {};

  for (const keyAndValue of query.split('&').filter((x: unknown) => !!x)) {
    const splitKeyAndValue = keyAndValue.split('=');
    assertValue(
      splitKeyAndValue[0],
      'url.ts > parseQuery > splitKeyAndValue[0]'
    );

    const key = decode(splitKeyAndValue[0]);

    if (!(key in result)) {
      result[key] = [];
    }

    if (splitKeyAndValue[1] !== '') {
      assertValue(
        splitKeyAndValue[1],
        'url.ts > parseQuery > splitKeyAndValue[1]'
      );
      if (Array.isArray(result[key])) {
        const array = result[key];
        assertValue(array, 'url.ts > parseQuery > array');
        array.push(decode(splitKeyAndValue[1]));
      }
    }
  }

  return result;
}

export function renderQuery(
  query: QueryString,
  prefixedByQuestionMark = false
): string {
  let result = prefixedByQuestionMark ? '?' : '';
  let prefix = '';
  for (const key of Object.keys(query)) {
    let values = query[key];
    assertValue(values, 'url.ts > renderQuery > values');

    if (values.length === 0) {
      values = [''];
    }

    for (const value of values) {
      result += `${prefix}${encode(key)}=${encode(value)}`;

      prefix = '&';
    }
  }

  return result;
}

function encode(value: string): string {
  return encodeURIComponent(value).replace('%20', '+');
}

function decode(value: string): string {
  return decodeURIComponent(value.replace('+', '%20'));
}

export function combineUrls(baseUrl: string, relativeUrl: string): string {
  return relativeUrl
    ? `${baseUrl.replace(/\/+$/, '')}/${relativeUrl.replace(/^\/+/, '')}`
    : baseUrl;
}
